import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Technology } from '../../../../types/globalTypes';
import { Box, Title, VerticalBox } from '../../../../components';
import { techIconMap } from '../../../../assets/techIcons';
import { TechnologyElement } from '../../../../components/Technology/TechnologyElement';
import { useTranslation } from 'react-i18next';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  icon?: string;
  objList: Technology[];
}

export const Technologies: React.FC<DivProps> = ({ objList, ...props }) => {
  const { t } = useTranslation();
  return (
    <SectionContainer $color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <VerticalBox>
          <SectionTextContainer $gap={80}>
            <Title title={t('screen.project.technologies')} isAnimated={true} />
            <TechnologiesContainer {...props}>
              {objList &&
                objList.map((el, index: number) => (
                  <TechnologyElement
                    key={index}
                    title={el.Name}
                    src={techIconMap[el.Name.trim()] || techIconMap.default}
                  />
                ))}
            </TechnologiesContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const TechnologiesContainer = styled(MotionYOffsetBlock)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, auto));
  column-gap: 115px;
  row-gap: 48px;
  background-color: ${COLORS.GRAY_BG_COLOR};
  padding: 40px;
  @media screen and (${device.lg}){
    column-gap: 48px;
  }
  @media screen and (${device.md}) {
    column-gap: 20px;
    row-gap: 10px;
  }
`;
